<ng-container *ngIf="productoLeaderGo">
  <div style="margin: 20px; width:100%" fxLayout="column" fxLayoutAlign="start strech">
    <div class="header accent p-24 " fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" (click)="regresar()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <ng-container>
        <h2 class="m-0 product_name2">{{'PORTAL.PRODUCTO.PORTAL' | translate}}</h2>
        <h2 class="m-0 product_name2">{{'PORTAL.PRODUCTO.NAME' | translate}} {{nombreEmpresaFinal}}</h2>
        <h2 class="m-0 product_name"> {{'PORTAL.PRODUCTO.PRODUCTO' | translate}} {{translate_name}}</h2>
      </ng-container>

    </div>
    <div class="divIframe">
      <!-- <form action="{{urlTableau}}" method="post" id="RecDatos" target="frameTableau">
      </form> -->
      <iframe  src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"></iframe>
    </div>
  </div>
  </ng-container>

<ng-container *ngIf="!productoLeaderGo">
  <div style="margin: 20px; width:100%" fxLayout="column" >

    <div class="header accent p-24 " fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" (click)="regresar()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <ng-container *ngIf="translate_name">
        <h2 class="m-0 product_name2">{{'PORTAL.PRODUCTO.PORTAL' | translate}}</h2>
        <h2 class="m-0 product_name2">{{'PORTAL.PRODUCTO.NAME' | translate}} {{nombreEmpresaFinal}}</h2>
        <h2 class="m-0 product_name"> {{'PORTAL.PRODUCTO.PRODUCTO' | translate}} {{translate_name}}</h2>
      </ng-container>

    </div>
    <ng-container *ngIf="cargando">
      <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
      </div>
    </ng-container>
    <ng-container *ngIf="!cargando">
      <!-- <ng-container *ngIf="!fechaAnterior"> -->
        <div class="" fxLayout="column">
          <div class="" fxLayout="row" fxLayoutAlign="start center">
            <h3 class="diaTranscu">{{'PORTAL.DI-TRANSCU' | translate}}</h3>
            <!-- <h3 class="diaTranscu">{{diasTranscurridos}}</h3> -->
          </div>
        </div>
        <div *ngIf="infoAvanceConteo && !fechaAnterior || statusNorma && !fechaAnterior" class="" fxLayout="row" fxLayoutAlign="space-between">
          <!-- <h3 class="mt-0 ml-10 tamañoletra">Fecha lanzamiento: {{fechaLanzamiento}}</h3> -->
          <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="80">
            <mat-progress-bar *ngIf="!validarIzzi && IdInstituto!=14" class="barcolor" mode="buffer" value="{{progreso}}"></mat-progress-bar>
            <mat-progress-bar *ngIf="validarIzzi" class="barcolorIzzi" mode="buffer" value="{{progreso}}"></mat-progress-bar>
            <mat-progress-bar *ngIf="IdInstituto==14" class="barcolorGCTI" mode="buffer" value="{{progreso}}"></mat-progress-bar>
            <!-- <h4 class="mt-0 mb-10 midText">{{progreso}}%</h4> -->
          </div>
          <h3 class="mt-0 ml-10 tamañoletra" *ngIf="!fechaAnterior">{{diasRestantes}} {{'PORTAL.DIARESTA' | translate}}</h3>
        </div>
        <!-- </ng-container> -->

        <!-- muestra cuando el instituto no es IZZI-->
        <ng-container *ngIf="!validarIzzi || IdInstituto!=14">

          <div *ngIf="infoAvanceConteo || statusNorma"  fxLayout="row" fxLayoutAlign="space-between">
            <!-- Total Usuarios -->
            <div class="p-20 m-10 tarjeta totalCol" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <h1 style="margin:0px">{{totalUsers}}</h1>
              <img class="imgtotalCol" src="{{urlImagenLog}}logos/total-users.png" alt="" fxLayoutAlign="center center">
              <mat-divider></mat-divider>
              <div style="margin-top:100px" class="texto " *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALCOLA' | translate}} </div>
              <div style="margin-top:100px"class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALCOLA' | translate}} </div>
            </div>

            <!-- Total Usuarios  queno han contestado-->
            <div class="p-20 m-10 tarjeta totalFal" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" >
              <h1 style="margin:0px">{{totalUsers-endUsers}}</h1>
              <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-not-responded.png" alt="" fxLayoutAlign="center center">
              <mat-divider></mat-divider>
              <div style="margin-top:100px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALFAL' | translate}}</div>
              <div style="margin-top:100px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALFAL' | translate}}</div>
            </div>

            <!-- Total Usuarios  que ya han contestado-->
            <div class="p-20 m-10 tarjeta totalCom" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" >
              <h1 style="margin:0px">{{endUsers}}</h1>
              <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-have-responded.png" alt="" fxLayoutAlign="center center">
              <mat-divider></mat-divider>
              <div style="margin-top:100px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALCONT' | translate}}</div>
              <div style="margin-top:100px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALCONT' | translate}}</div>
            </div>
            <!-- Caja total de porcentaje de avance -->
            <div class="p-20 m-10 tarjeta totalPro" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" >
              <!-- CONTEOS NORMAL -->
              <h1 style="margin:0px" *ngIf="!statusNorma">{{this.porcentajeUsers}}%</h1>
              <h1 style="margin:0px" *ngIf="statusNorma">{{this.porcentajeUsers}}</h1>
              <img class="imgtotalCol" src="{{urlImagenLog}}logos/meta.png" alt="" fxLayoutAlign="center center">
              <mat-divider></mat-divider>
              <div style="margin-top:100px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALPRO' | translate}}</div>
              <div style="margin-top:100px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALPRO' | translate}}</div>
            </div>

            <ng-container *ngIf="resultsBoxEntregables">
              <div class="p-20 m-10 tarjeta reporte " fxLayout="column" fxLayoutAlign="start stretch"  fxFlex="fxFlexEspacio" *ngIf="tipoProducto == '1' || tipoProducto == 'c1' || tipoProducto == 'c3'|| tipoProducto == 'm7'|| tipoProducto == 'p1' || tipoProducto == 'c6'" >
                <h1 style="margin:0px">{{respRecRes}} {{'PORTAL.COLAB' | translate}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/report.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <button  class="btnverMas texto" fxLayoutAlign="center center"  matTooltipClass="tooltip" matTooltip="{{textToolResultsBoxEntregables | translate}}" matTooltipPosition="below">{{textResultsBoxEntregables | translate}}</button>
                <!-- <button style="margin-top:5px" class="texto" fxLayoutAlign="center center">{{textResultsBoxEntregables | translate}}</button> -->
              </div>
            </ng-container>

            <ng-container *ngIf="resultsBoxRanking">
              <div class="p-20 m-10 tarjeta ranking" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio"  *ngIf="tipoProducto == '1' || tipoProducto == 'c1' || tipoProducto == 'c3' || tipoProducto == 'm7'|| tipoProducto == 'p1' || tipoProducto == 'c6' ">
                <h1 style="margin:0px">{{respMinCer}} {{'PORTAL.COLAB' | translate}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/ranking.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <!-- <div style="margin-top:5px" class="texto" fxLayoutAlign="center center">{{textResultsBoxRanking | translate}}</div> -->
                <button  class="btnverMasRanking texto" matTooltipClass="tooltipRanking" matTooltip="{{textToolResultsBoxRanking | translate}}" matTooltipPosition="below">{{textResultsBoxRanking | translate}}</button>
              </div>
            </ng-container>
          </div>

        </ng-container>

        <!-- muestra cuando el instituto es IZZI-->
        <ng-container *ngIf="validarIzzi && IdInstituto==14">

          <div *ngIf="infoAvanceConteo || statusNorma" class="" fxLayout="row" fxLayoutAlign="space-between">
            <!-- Total Usuarios -->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalColIzzi" fxLayout="column" fxLayoutAlign="center center" >
                <h1 style="margin:0px">{{totalUsers}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/total-users-izzi.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALCOLA' | translate}} </div>
                <div style="margin-top:5px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALCOLA' | translate}} </div>
              </div>
            </div>
            <!-- Total Usuarios  queno han contestado-->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalFalIzzi" fxLayout="column" fxLayoutAlign="center center">
                <h1 style="margin:0px">{{totalUsers-endUsers}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-not-responded-izzi.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALFAL' | translate}}</div>
                <div style="margin-top:5px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALFAL' | translate}}</div>
              </div>
            </div>
            <!-- Total Usuarios  que ya han contestado-->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalComIzzi" fxLayout="column" fxLayoutAlign="center center">
                <!--<h1>{{infoAvanceConteo.avance.endUsers}}</h1>-->
                <h1 style="margin:0px">{{endUsers}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-have-responded-izzi.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALCONT' | translate}}</div>
                <div style="margin-top:5px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALCONT' | translate}}</div>
              </div>
            </div>
            <!-- Caja total de porcentaje de avance -->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalProIzzi" fxLayout="column" fxLayoutAlign="center center">
                <h1 style="margin:0px" *ngIf="!statusNorma">{{this.porcentajeUsers}}%</h1>
                <h1 style="margin:0px" *ngIf="statusNorma">{{this.porcentajeUsers}}</h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/meta-izzi.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALPRO' | translate}}</div>
                <div style="margin-top:5px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALPRO' | translate}}</div>

              </div>
            </div>
            <!-- Caja total de porcentaje de los que no contestan -->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="statusNorma">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalLog" fxLayout="column" fxLayoutAlign="center center">
                <h1 style="margin:0px">{{uncomplete_users}} </h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/users-not-finish.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALLOG' | translate}}</div>
                <div style="margin-top:5px"  class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALLOG' | translate}}</div>

              </div>
            </div>

            <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="statusNorma">
              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalGone" fxLayout="column" fxLayoutAlign="center center">
                <h1 style="margin:0px">{{goneUser}} </h1>
                <img class="imgtotalCol" src="{{urlImagenLog}}logos/gone.png" alt="" fxLayoutAlign="center center">
                <mat-divider></mat-divider>
                <div style="margin-top:5px" class="texto" *ngIf="!statusNorma" fxLayoutAlign="center center">{{'PORTAL.TOTALGONE' | translate}}</div>
                <div style="margin-top:5px" class="texto" *ngIf="statusNorma" fxLayoutAlign="center center">{{'PORTAL35.TOTALGONE' | translate}}</div>

              </div>
            </div>

            <ng-container *ngIf="resultsBoxEntregables">
              <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto == '1' || tipoProducto == 'c1' || tipoProducto == 'c3'" >
                <div class="mat-elevation-z2 p-20 m-10 tarjeta reporte" fxLayout="column" fxLayoutAlign="center center">
                  <h1 style="margin:0px">{{respRecRes}} {{'PORTAL.COLAB' | translate}}</h1>
                  <!-- <h1 style="margin:0px">{{totalUsers*0.85 | number:'1.0-0'}} {{'PORTAL.COLAB' | translate}}</h1> -->
                  <img class="imgtotalCol" src="{{urlImagenLog}}logos/report.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:5px" class="texto" fxLayoutAlign="center center">{{textResultsBoxEntregables | translate}}</div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="resultsBoxRanking">
              <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="fxFlexEspacio" *ngIf="tipoProducto == '1' || tipoProducto == 'c1' || tipoProducto == 'c3' ">
                <div class="mat-elevation-z2 p-20 m-10 tarjeta ranking" fxLayout="column" fxLayoutAlign="center center">
                  <h1 style="margin:0px">{{respMinCer}} {{'PORTAL.COLAB' | translate}}</h1>
                  <img class="imgtotalCol" src="{{urlImagenLog}}logos/ranking.png" alt="" fxLayoutAlign="center center">
                  <mat-divider></mat-divider>
                  <div style="margin-top:5px" class="texto" fxLayoutAlign="center center">{{textResultsBoxRanking | translate}}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>


        <div class="mt-20" fxLayout="row" fxLayoutAlign="end">
          <div class="" fxLayout="row" fxLayoutAlign="start end" fxFlex="50" *ngIf="showUsers">
            <!--<button mat-raised-button class="mb-20 primary" (click)="openDialog()" *ngIf="!statusNorma">
              {{'BTN.USERS' | translate}}
              <mat-icon class="ml-20">dvr icon</mat-icon>
            </button>-->
          </div>
        </div>

        <div class="ZonaHoraria">{{'PORTAL.ETI_GRAFI_ZONA_HO' | translate}} ({{city_name | translate}} {{logDate |date:'O':offsetPipe:idiomaActual}})</div>

        <ng-container *ngIf="!fechaAnterior">
          <div class="" fxLayout="row" fxLayoutAlign="center stretch" *ngIf="datosEncontrados">
            <canvas baseChart fxFlex="100" height="65px" [labels]="lineChartLabels" [datasets]="lineChartData" [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType">
            </canvas>
          </div>
        </ng-container>

        <div *ngIf="instituto=='CAyC'" class="statusDivAlert"  fxFlex="90">
          <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'PORTAL.WAR_RESU_ARE_MIN5' | translate}} </h2>
            <mat-icon class="ml-20 s-40">warning</mat-icon>
          </div>
        </div>
        <!-- <mat-checkbox [(ngModel)]="checked" (click)="checkCargo()">charge</mat-checkbox> -->

        <!-- TABLA NUEVO DE FILTROS -->
        <ng-container *ngIf="cargandoTablaFiltros">
          <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
          </div>
        </ng-container>
        <mat-tab-group *ngIf="!cargandoTablaFiltros && !statusNorma" (selectedTabChange)="onLinkClick($event)">

          <!-- PORTAL DE CONTEOS V1 -->
          <mat-tab label="{{'PORTAL.PORTAL_V1' | translate}}">
            <div class="btnFltros" fxLayout="row" fxLayoutAlign="start center" fxFlex="50">
              <button mat-raised-button class="mb-20 primary" (click)="descargarExcelReducido()" *ngIf="!statusNorma">
                {{'PORTAL.EXCEL.NOMBOTON' | translate}}
                <mat-icon class="ml-20">cloud_download</mat-icon>
              </button>
            </div>

            <div class="EtiquetaFiltros">
              {{'PORTAL.ETI_FILT_V1&V2' | translate}}
            </div>
            <button mat-raised-button color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menuPrin">
              {{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}
              <mat-icon>filter_list</mat-icon>
            </button>
            <mat-menu #menuPrin="matMenu" class="matMenuFiltros">
              <button mat-menu-item *ngFor="let item of catalogoFiltrosReducido">
                <div fxLayout="row" fxLayoutAlign="space-between start">
                <p *ngIf="instituto!='HK'">{{'PORTAL.FILTROS_V2.'+item.nombrefiltro | translate}}</p>
                <p *ngIf="instituto=='HK'">{{'PORTAL.FILTROS_V2_HK.'+item.nombrefiltro | translate}}</p>
                <mat-checkbox (change)="muestraDemoGra($event,item)" [(ngModel)]="item.visible" ></mat-checkbox>
              </div>
            </button>
              <!-- <mat-checkbox  style="width:100%!important" *ngFor="let item of catalogoFiltrosReducido" (change)="muestraDemoGra($event,item)" [(ngModel)]="item.visible">{{'PORTAL.FILTROS_V2.'+item.nombrefiltro | translate}}</mat-checkbox> -->
            </mat-menu>
                  <div class="mat-elevation-z8" *ngIf="!cargandoTablaFiltros && !statusNorma">
                    <table mat-table [dataSource]="filtroPortalv2Reducido">

                      <!-- DEMOGRAFICO -->
                      <ng-container matColumnDef="demografico">
                        <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.DEMOGRAFICO' | translate}}
                          <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                            <mat-icon>filter_list</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu" class="matMenuFiltros">
                            <button mat-menu-item (click)="seleccionarFiltroReducido('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                            <ng-container *ngFor="let item of catalogoFiltrosReducido">
                              <button *ngIf="item.visible" mat-menu-item (click)="seleccionarFiltroReducido(item.nombrefiltro)">
                                <p *ngIf="instituto!='HK'">{{'PORTAL.FILTROS_V2.'+item.nombrefiltro | translate}}</p>
                                <p *ngIf="instituto=='HK'">{{'PORTAL.FILTROS_V2_HK.'+item.nombrefiltro | translate}}</p>
                               </button>
                            </ng-container>
                          </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let element" style="width: 13%;">

                          <p *ngIf="instituto!='HK'">{{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}</p>
                          <p *ngIf="instituto=='HK'">{{'PORTAL.FILTROS_V2_HK.'+element.FILTRO | translate}}</p>


                        </td>
                      </ng-container>

                      <!-- SEGMENTO -->
                      <ng-container matColumnDef="segmento">
                        <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.SEGMENTO' | translate}}
                          <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                            <mat-icon>filter_list</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu" class="matMenuFiltros">
                            <button mat-menu-item (click)="seleccionarFiltroReducido2('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                            <button mat-menu-item *ngFor="let item of catalogoFiltrosSegmentoReducido" (click)="seleccionarFiltroReducido2(item)">{{item}}</button>
                          </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let element" style="width: 13%;" > {{element.SEGMENTO}} </td>
                      </ng-container>

                      <!-- COLABORADORES TOTALES -->
                      <ng-container matColumnDef="colaboradoresTotales">
                        <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.COLABORADORES_T' | translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.TOTAL_DE_COLABORADORES}} </td>
                      </ng-container>

                      <!-- PENDIENTES POR RESPONDER -->
                      <ng-container matColumnDef="pendientesResponder">
                        <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER' | translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_AUN_NO_RESPONDEN}} </td>
                      </ng-container>

                      <!-- YA RESPONDIERON -->
                      <ng-container matColumnDef="respondieron">
                        <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON' | translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_YA_RESPONDIERON}} </td>
                      </ng-container>

                      <!-- AVANCE -->
                      <ng-container matColumnDef="avance">
                        <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.AVANCE' | translate}} </th>
                        <td mat-cell *matCellDef="let element" style="width: 100%;">
                          <div *ngIf="element.COLABORADORES_QUE_YA_RESPONDIERON!='*' || element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*'" class="" fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="90"> <br>
                            <mat-progress-bar class="prro" mode="buffer" value="{{(element.PROGRESO_TOTAL*100).toFixed(2)}}"></mat-progress-bar>
                            <p class="mt-0 mb-10 midTextV2">{{(element.PROGRESO_TOTAL*100).toFixed(2)}}%</p>
                          </div>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsReducido"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsReducido;"></tr>
                    </table>
                  </div>
          </mat-tab>

                <!-- PORTAL DE CONTEOS V2 -->
                <mat-tab label="{{'PORTAL.PORTAL_V2' | translate}}">
                  <div class="btnFltros" fxLayout="row" fxLayoutAlign="start center" fxFlex="50">
                    <button mat-raised-button class="mb-20 primary" (click)="seleccionarFiltro('');
                    seleccionarFiltro2('');
                    seleccionarFiltro3('');
                    seleccionarFiltro4('');">
                    {{'PORTAL.ETIQUETAS.BOTON' | translate}}
                    <mat-icon class="ml-20">update</mat-icon>
                  </button> &nbsp;

                  <button mat-raised-button class="mb-20 primary" (click)="descargarExcelV2()" *ngIf="!statusNorma">
                    {{'PORTAL.EXCEL.NOMBOTON' | translate}}
                    <mat-icon class="ml-20">cloud_download</mat-icon>
                  </button>
                </div>
                <div class="EtiquetaFiltros">
                  {{'PORTAL.ETI_FILT_V1&V2' | translate}}
                </div>
                <div class="mat-elevation-z8" *ngIf="!cargandoTablaFiltros && !statusNorma">
                  <table mat-table [dataSource]="filtroPortalv2">

                    <!-- NIVEL 1 -->
                    <ng-container matColumnDef="nivel1">
                      <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.NIVEL1' | translate}}
                        <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                          <mat-icon>filter_list</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="matMenuFiltros">
                          <button mat-menu-item (click)="seleccionarFiltro('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                          <button mat-menu-item *ngFor="let item of catalogoFiltrosN1" (click)="seleccionarFiltro(item)">{{item}}</button>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.Nivel_1}} </td>
                    </ng-container>

                    <!-- NIVEL 2 -->
                    <ng-container matColumnDef="nivel2">
                      <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.NIVEL2' | translate}}
                        <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                          <mat-icon>filter_list</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="matMenuFiltros">
                          <button mat-menu-item (click)="seleccionarFiltro2('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                          <button mat-menu-item *ngFor="let item of catalogoFiltrosN2" (click)="seleccionarFiltro2(item)">{{item}}</button>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.Nivel_2}} </td>
                    </ng-container>

                    <!-- DEMOGRAFICO -->
                    <ng-container matColumnDef="demografico">
                      <th mat-header-cell *matHeaderCellDef>{{'PORTAL.COLUMNAS_TABLA.DEMOGRAFICO' | translate}}
                        <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                          <mat-icon>filter_list</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="matMenuFiltros">
                          <button mat-menu-item (click)="seleccionarFiltro3('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                          <button mat-menu-item *ngFor="let item of catalogoFiltros" (click)="seleccionarFiltro3(item)">
                            <ng-container *ngIf="item==nombreEmpresaFinal">
                              {{item}}
                            </ng-container>
                            <ng-container *ngIf="item!=nombreEmpresaFinal">
                              {{'PORTAL.FILTROS_V2.'+item | translate}}
                            </ng-container>

                          </button>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;">
                        <ng-container *ngIf="element.nivel1!=Company">
                          {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}
                        </ng-container>
                        <ng-container *ngIf="element.nivel1==Company">
                          <ng-container *ngIf="element.FILTRO==nombreEmpresaFinal">
                            {{element.FILTRO}}
                          </ng-container>
                          <ng-container *ngIf="element.FILTRO!=nombreEmpresaFinal">
                            {{'PORTAL.FILTROS_V2.'+element.FILTRO | translate}}
                          </ng-container>
                        </ng-container>
                      </td>
                    </ng-container>

                    <!-- SEGMENTO -->
                    <ng-container matColumnDef="segmento">
                      <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.SEGMENTO' | translate}}
                        <button mat-mini-fab color="warn" matTooltip="{{'PORTAL.COLUMNAS_TABLA.FILTERS' | translate}}" [matMenuTriggerFor]="menu">
                          <mat-icon>filter_list</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="matMenuFiltros">
                          <button mat-menu-item (click)="seleccionarFiltro4('')">{{'PORTAL.FILTROS_V2.ninguno' | translate}}</button>
                          <button mat-menu-item *ngFor="let item of catalogoFiltrosSegmento" (click)="seleccionarFiltro4(item)">{{item}}</button>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.SEGMENTO}} </td>
                    </ng-container>

                    <!-- COLABORADORES TOTALES -->
                    <ng-container matColumnDef="colaboradoresTotales">
                      <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.COLABORADORES_T' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.TOTAL_DE_COLABORADORES}} </td>
                    </ng-container>

                    <!-- PENDIENTES POR RESPONDER -->
                    <ng-container matColumnDef="pendientesResponder">
                      <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.PENDIENTES_RESPONDER' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_AUN_NO_RESPONDEN}} </td>
                    </ng-container>

                    <!-- YA RESPONDIERON -->
                    <ng-container matColumnDef="respondieron">
                      <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.YA_RESPONDIERON' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 13%;"> {{element.COLABORADORES_QUE_YA_RESPONDIERON}} </td>
                    </ng-container>

                    <!-- AVANCE -->
                    <ng-container matColumnDef="avance">
                      <th mat-header-cell *matHeaderCellDef> {{'PORTAL.COLUMNAS_TABLA.AVANCE' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 100%;">
                        <div *ngIf="element.COLABORADORES_QUE_YA_RESPONDIERON!='*' || element.COLABORADORES_QUE_AUN_NO_RESPONDEN!='*'" class="" fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-sm="90"> <br>
                          <mat-progress-bar class="prro" mode="buffer" value="{{(element.PROGRESO_TOTAL*100).toFixed(2)}}"></mat-progress-bar>
                          <p class="mt-0 mb-10 midTextV2">{{(element.PROGRESO_TOTAL*100).toFixed(2)}}%</p>
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>

                  <mat-paginator [pageSizeOptions]="[10, 25, 100, 500]" showFirstLastButtons style="margin-bottom: 250px;"></mat-paginator>
                </div>
              </mat-tab>
            </mat-tab-group>

            <!-- TERMINA TABLA NUEVA DE FILTROS -->

            <!-- SECOND SELECT-->
            <div class="" fxLayout="column" fxLayoutAlign="start stretch">
              <!-- <h1>Filtros</h1> -->
              <div class="" fxLayout="row" fxLayoutAlign="center">
              </div>
              <div class="" fxLayout="row" fxLayoutAlign="space-between">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                  <mat-form-field appearance="outline" fxFlex="100" *ngIf="statusNorma">
                    <mat-label *ngIf="selectType">{{'PORTAL35.SELECTFPLA' | translate}}</mat-label>
                    <mat-label *ngIf="!selectType">{{nombreCT}}</mat-label>

                    <mat-select placehoder>
                      <mat-option *ngFor="let CT of centrosTrabajo" (click)="getCT_info(CT.centro.id_CT,CT.centro.nombre_CT)">
                        <!-- <mat-option > -->
                          <!-- {{institute.regionInstituto}} -->
                          {{CT.centro.nombre_CT}}_{{CT.centro.id_CT}}
                        </mat-option>
                      </mat-select>
                      <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                      <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                    </mat-form-field>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100" *ngIf="statusNorma">
                      <mat-label>{{'PORTAL.SELECTFPLA' | translate}}</mat-label>
                      <mat-select [disabled]="estatusCT">

                        <mat-option *ngFor="let filtro of listaFiltros" [value]="filtro.id" (click)="getConteosF(filtro.id,filtro.nombre )">
                          <!-- <mat-option > -->
                            <!-- {{institute.regionInstituto}} -->
                            {{'PORTAL35.FILTROS.'+filtro.id | translate}}
                          </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                        <mat-error>{{'PERFILES.EMPRESA.SECCIONES.SEC1.INSTITUTO_REQUIRED' | translate}}</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- FIN SECOND SELECT-->


                <div class="" fxLayout="column" fxLayoutAlign="start stretch">

                  <div class="" fxLayout="row" fxLayoutAlign="center">
                    <h1 *ngIf="!statusNorma && !portalValidacion">{{nombre}}</h1>
                    <h1 *ngIf="statusNorma">{{nombre35}}</h1>
                  </div>
                  <div class="" fxLayout="column" fxLayoutAlign="space-between">
                    <ng-container *ngIf="cargandoFiltros">
                      <div class="mt-20" fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="resultadoConteo && !cargandoFiltros && portalValidacion">
                      <div *ngFor="let resultado of resultadoConteo.resultado; let k = index;" fxLayout="column" fxLayoutAlign="" fxFlex="50">
                        <ng-container *ngIf="instituto=='TK'">
                          <ng-container *ngIf="!mensaje">
                            <ng-container *ngIf="resultado.totalUsers>5">
                              <h3>{{resultado.filtro}}</h3>
                              <div class="" fxLayout="row" fxLayoutAlign="start start">
                                <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="90">
                                  <mat-progress-bar class="prro" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                  <h4 class="mt-0 mb-10 midText">{{'PORTAL.TBARRAPROGRESO' | translate}}: {{resultado.porcentaje}}%</h4>

                                </div>

                                <h3 class="mt-0 ml-10 tamañoletra">[{{resultado.endUsers}}/{{resultado.totalUsers}}]</h3>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="instituto!='TK'">
                          <ng-container *ngIf="!mensaje">
                            <h3>{{resultado.filtro}}</h3>
                            <div class="" fxLayout="row" fxLayoutAlign="start start">
                              <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="90">
                                <mat-progress-bar *ngIf="!validarIzzi && IdInstituto!=14" class="prro" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                <mat-progress-bar *ngIf="validarIzzi" class="izzi" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                <mat-progress-bar *ngIf="IdInstituto==14" class="gcti" mode="buffer" value="{{resultado.porcentaje}}"></mat-progress-bar>
                                <h4 class="mt-0 mb-10 midText">{{'PORTAL.TBARRAPROGRESO' | translate}}: {{resultado.porcentaje}}%</h4>

                              </div>

                              <h3 class="mt-0 ml-10 tamañoletra">[{{resultado.endUsers}}/{{resultado.totalUsers}}]</h3>
                            </div>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="statusFiltroCT">
                          <div class="" fxLayout="column" fxLayoutAlign="start center" *ngIf="statusNorma">
                            <div fxLayout="row" fxLayoutAlign="space-around center" fxFlex.gt-sm="90">
                              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalCol" fxFlex.gt-sm="90">
                                <div class="">
                                  <h1>{{ resultadoConteo.resultado[k].totalUsers }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALCOLA' | translate}}</div>
                                </div>
                              </div>
                              <div class="mat-elevation-z2 p-20 m-10 tarjeta totalFal" fxFlex.gt-sm="90">
                                <div class="">
                                  <h1>{{ resultadoConteo.resultado[k].totalUsers - resultadoConteo.resultado[k].endUsers }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALFAL' | translate}}</div>
                                </div>

                              </div>
                              <div fxFlex.gt-sm="90" class="mat-elevation-z2 p-20 m-10 tarjeta totalCom">
                                <div class="">
                                  <h1>{{ resultadoConteo.resultado[k].endUsers }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALCONT' | translate}}</div>
                                </div>

                              </div>
                              <div fxFlex.gt-sm="90" class="mat-elevation-z2 p-20 m-10 tarjeta totalPro">
                                <div class="">
                                  <h1>{{ Array_muestra[k] }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALPRO' | translate}}</div>
                                </div>

                              </div>
                              <div fxFlex.gt-sm="90" class="mat-elevation-z2 p-20 m-10 tarjeta totalLog">
                                <div class="">
                                  <h1>{{ Array_Log[k] }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALLOG' | translate}}</div>
                                </div>

                              </div>
                              <div fxFlex.gt-sm="90" class="mat-elevation-z2 p-20 m-10 tarjeta totalGone">
                                <div class="">
                                  <h1>{{ Array_gone[k] }}</h1>
                                </div>

                                <div class="mt-20">
                                  <div class="" style="padding-top: 65px;">{{'PORTAL35.TOTALGONE' | translate}}</div>
                                </div>

                              </div>

                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>


                </div>
                <ng-container *ngIf="mensaje">
                  <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
                    <h1 class="h1 secondary-text">
                      <p class="textoN">{{'PORTAL.NO-INFO' | translate}}</p>
                    </h1>
                  </div>
                </ng-container>
              </ng-container>

  </div>
</ng-container>
